export enum ConfirmPopupAction {
    Close = 'close',
    Back = 'back',
}

export interface ButtonStyle {
    variant: 'filled' | 'outline' | 'flat' | 'flat-reduced';
    size: 'small' | 'medium' | 'large';
    kind: 'primary' | 'secondary' | 'tertiary' | 'success' | 'utility';
    inverse?: boolean;
}
